import React from "react";
import { FeatherArrowRight } from "@subframe/core";

export type AttentionVariant = "error" | "brand";

export interface AttentionItemCardProps {
  variant: AttentionVariant;
  title: string;
  description: string;
  actionLabel: string;
  onAction?: () => void;
}

const variantClasses: Record<
  AttentionVariant,
  { border: string; bg: string; dot: string; action: string }
> = {
  error: {
    border: "border-error-500",
    bg: "bg-error-50",
    dot: "bg-error-500",
    action: "text-error-600",
  },
  brand: {
    border: "border-brand-400",
    bg: "bg-brand-50",
    dot: "bg-brand-500",
    action: "text-brand-600",
  },
};

export function AttentionItemCard({
  variant,
  title,
  description,
  actionLabel,
  onAction,
}: AttentionItemCardProps) {
  const c = variantClasses[variant];
  const isActionable = typeof onAction === "function";
  return (
    <div
      className={`flex w-full items-center justify-between rounded-lg border-l-4 border-solid ${c.border} ${c.bg} px-5 py-4`}
    >
      <div className="flex items-start gap-4">
        <div
          className={`flex h-2 w-2 flex-none flex-col items-start rounded-full ${c.dot} mt-1.5`}
        />
        <div className="flex flex-col items-start gap-1">
          <span className="text-heading-3 font-heading-3 text-neutral-900">
            {title}
          </span>
          <span className="text-body font-body text-neutral-600">
            {description}
          </span>
        </div>
      </div>
      <button
        type="button"
        onClick={onAction}
        disabled={!isActionable}
        className={`group flex items-center gap-2 bg-transparent border-none ${c.action} ${
          isActionable
            ? "cursor-pointer transition-colors hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
            : "cursor-default opacity-60"
        }`}
      >
        <span className="text-body-bold font-body-bold">{actionLabel}</span>
        <FeatherArrowRight className="text-body font-body transition-transform group-hover:translate-x-0.5" />
      </button>
    </div>
  );
}
